import React from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import {
  Box,
  Divider,
  FormControlLabel,
  IconButton,
  LinearProgress,
  Radio
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import {
  allCocoonsLoadingState,
  allCocoonsState,
  displayCocoonState,
  S3File
} from 'features/file-browser/state/fileAtoms';
import { isVisibleCocoonState } from 'features/three-view/state/threeAtoms';
import { CustomTypography } from 'shared/ui/CustomTypography';

interface Props {
  subtitle: string;
};

const iconSx = {
  fontSize: 12,
  color: '#e1e1e1'
};

const boxSx = {
  backgroundColor: '#404040',
  borderRadius: '5px',
  height: '80%',
  overflow: 'auto',
};

const radioSx = {
  color: '#e9e9e9',
  '&.Mui-checked': {
    color: '#1976d2',
  },
  transform: 'scale(.9)',
};

export const DisplayCocoonPanel: React.FC<Props> = ({
  subtitle,
}) => {
  const [displayCocoon, setDisplayCocoon] = useRecoilState(displayCocoonState);
  const [isVisibleCocoon, setisVisibleCocoon] = useRecoilState(isVisibleCocoonState);
  const allCocoons = useRecoilValue(allCocoonsState);
  const loading = useRecoilValue(allCocoonsLoadingState);

  const handleToggle = () => {
    setisVisibleCocoon((prev) => !prev);
  };

  const handleRadioChange = (file: S3File) => {
    setDisplayCocoon(file);
  };

  return (
    loading ? (
      <Box component="div">
        <LinearProgress />
      </Box>
    ) : (
      <Box component="div" sx={{ height: '100%', width: '100%' }}>

        <Box component="div" sx={{ display: 'flex', alignItems: 'center', height: '8%' }}>
          <CustomTypography >{subtitle}</CustomTypography>
          <IconButton onClick={handleToggle}>
            {isVisibleCocoon ? <VisibilityIcon sx={iconSx} /> : <VisibilityOffIcon sx={iconSx} />}
          </IconButton>
        </Box>

        <Divider sx={{ my: 0.5, bgcolor: '#e1e1e1' }} />

        <Box component="div" sx={boxSx}>
          {allCocoons.map((file) => (
            <Box key={file.name} component="div" sx={{ display: 'flex', alignItems: 'center', mb: -2, ml: 2 }}>
              <FormControlLabel
                control={
                  <Radio
                    sx={radioSx}
                    checked={displayCocoon?.name === file.name}
                    onChange={() => handleRadioChange(file)}
                    name="fileSelection"
                  />
                }
                label={<CustomTypography>{file.name}</CustomTypography>}
              />
            </Box>
          ))}
        </Box>

      </Box >
    )
  );
};
